module.exports = __webpack_public_path__ + "static/media/ktp_guide_blurry.4bc28d12.svg";